import { render, staticRenderFns } from "./classIntroduction.vue?vue&type=template&id=61d6651c&scoped=true"
import script from "./classIntroduction.vue?vue&type=script&lang=js"
export * from "./classIntroduction.vue?vue&type=script&lang=js"
import style0 from "./classIntroduction.vue?vue&type=style&index=0&id=61d6651c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6651c",
  null
  
)

export default component.exports